/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ListStyleLowerRoman(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ListStyleLowerRoman',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"opacity":".6","fillRule":"evenodd","clipRule":"evenodd","d":"M15 3H7v2h8V3zm0 8H7v2h8v-2z","fill":"currentColor"}),createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M5 1H4v1h1V1zm0 2H4v3h1V3zm0 6H4v1h1V9zm0 2H4v3h1v-3zM3 9H2v1h1V9zm0 2H2v3h1v-3z","fill":"currentColor"}))
}
